import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from 'src/providers/login.service';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { CoursesService } from 'src/providers/courses.service';
import { DashboardService } from 'src/providers/dashboard.service';

declare var $:any;

@Component({
  selector: 'app-why-iquanta-best',
  templateUrl: './why-iquanta-best.component.html',
  styleUrls: ['./why-iquanta-best.component.scss']
})
export class WhyIquantaBestComponent implements OnInit{

  @Input('hideButton') hideButton:any = false;

 constructor(public dialog: MatDialog, @Inject(DOCUMENT) private doc: Document, public matSnackBar: MatSnackBar,
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public router: Router, public loginService: LoginService,
    public deviceService: DeviceDetectorService, @Inject(DOCUMENT) public document: any, public dashboardService: DashboardService,
    public formBuilder: FormBuilder, public coursesService: CoursesService) {

    // this.scriptService.load('gtm', 'platform', 'jquery', 'popper', 'bootstrap', 'slick', 'video', 'katex', 'moment', 'timezone', 'pdf', 'swiper');
  }
  examList: any[] = ['CAT', 'XAT', 'CMAT', 'MICAT']
  examList1: any[] = ['CUET UG', 'CUET PG', 'IPMAT', 'CLAT']
  examList2: any[] = ['JEE Main', 'JEE Advance', 'BITSAT']
  examList3: any[] = ['NEET']
  examList4: any[] = ['GMAT', 'SAT', 'IELTS', 'GRE']
  callBackForm!: FormGroup;

  ngOnInit(): void {
     this.callBackForm = this.formBuilder.group({
          name: ['', Validators.required],
          email: ['', Validators.compose([Validators.required, Validators.email])],
          phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
          year: ['', Validators.required],
          course:['']
        })
  }

  selectedCategory: any[] = []
  selectedExams: any[] = []
  selectedExams1: any[] = []
  selectedExams2: any[] = []
  selectedExams3: any[] = []
  selectedExams4:any[]=[]
  getExamCategory1() {
    this.callBackForm.value.course.forEach((course: any) => {
      if (this.examList.includes(course)) {
        if (!this.selectedCategory.includes('MBA')) {
          this.selectedCategory.push('MBA')
        }
        this.selectedExams.push(course)
      }else if(this.examList1.includes(course)){
        if (!this.selectedCategory.includes('After 12th')) {
          this.selectedCategory.push('After 12th')
        }
        this.selectedExams1.push(course)
      }else if(this.examList2.includes(course)){
        if (!this.selectedCategory.includes('Engineering')) {
          this.selectedCategory.push('Engineering')
        }
        this.selectedExams2.push(course)
      }else if(this.examList4.includes(course)){
        if (!this.selectedCategory.includes('Study Abroad')) {
          this.selectedCategory.push('Study Abroad')
        }
        this.selectedExams4.push(course)
      }
        else {
          if (!this.selectedCategory.includes('Medical')) {
            this.selectedCategory.push('Medical')
          }
          this.selectedExams3.push(course)
      }
    })
    this.addInternalCRMLead('Course Enquiry')
  }

  openModal(val:any){
    $('#'+val).modal('show')
  }

  selectCat(val:any){
    if (this.callBackForm.value.course.includes(val)) {
      this.callBackForm.value.course.splice(this.callBackForm.value.course.indexOf(val), 1)
    } else {
      let list:any[]=[];
      if(this.callBackForm.value.course){
        list = this.callBackForm.value.course;

      }
      list.push(val)
      this.callBackForm.controls['course'].setValue(list)
    }
  }

  addInternalCRMLead(typ: any) {
    this.selectedCategory.forEach((cat: any) => {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "name": this.callBackForm.value.name,
        "firstName": this.callBackForm.value.name,
        "phone":  this.callBackForm.value.phone,
        "email":  this.callBackForm.value.email,
        "countryCode": 91,
        "source": "Website",
        "medium": "Free Counselling",
        "campaign": typ,
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId":  9999,
        "registrationDate": new Date().valueOf(),
        "pageLocation": this.doc.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.doc.URL,
        "registrationDevice": this.deviceService.deviceType,
        "customFields": {
          "exam": cat == 'MBA' ? this.selectedExams.join(',') : cat == 'Engineering' ? this.selectedExams2.join(',')  : cat == 'Medical' ?  this.selectedExams3.join(',')  : cat == 'Study Abroad' ? this.selectedExams4.join(',') : this.selectedExams1.join(','),
          "examCategory": cat,
          "examTargetYear":  this.callBackForm.value.year ,
          "leadPriority": "Platinum",
        },
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "source": "Website",
            "medium": "Free Counselling",
            "campaign": typ,
            adContent: "",
            "pageLocation": this.doc.URL,
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];

        }else{
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
        }
      }, err => {
        if (err.statusText == 'Unknown Error') {
          this.callBackLead(reqObj)
        }
      })
    })
  }

  callBackLead(reqObj: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {
      this.selectedCategory = [];
      this.selectedExams = [];
          this.selectedExams1 = [];
    })
  }
  submittedBtn:boolean = false;
  courseEnquiry() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: this.callBackForm.value.course,
        year: this.callBackForm.value.year,
        page_location: this.sessionStorage.getItem('utmLink') ? this.doc.URL + '?' + this.sessionStorage.getItem('utmLink') : this.doc.URL
      }
      this.coursesService.callback(reqObj).subscribe(res => {
        // this.dialogRef.close(res)
        if (res.success) {
          this.getExamCategory1()
          this.addNPF()
          // this.sessionStorage.setItem('dialogCloseTime', new Date().getTime().toString());
        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }
  }

  addNPF() {
    let medium: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": this.callBackForm.value.course,
      "field_exam": this.callBackForm.value.course,
      "field_course_year": this.callBackForm.value.year,
      "source": "Website " + medium,
      "medium": "Call Back Form",
      "field_lead_priority": 'Gold',
      "field_page_location": this.sessionStorage.getItem('utmLink') ? this.doc.URL + '?' + this.sessionStorage.getItem('utmLink') : this.doc.URL
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      if (res.message == "Mobile number already exists." || res.status == 'Successfully updated') {
        let reqData = {
          "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
          "college_id": "5802",
          "user_id": res.data.user_id,
          "name": this.callBackForm.value.name,
          "field_last_name": '',
          "country_dial_code": "+91",
          "mobile": this.callBackForm.value.phone,
          "email": this.callBackForm.value.email,
          "field_gender": '',
          "field_exam_category": "",
          "field_exam": this.callBackForm.value.course,
          "field_course_year": '',
          "source": "Website " + medium,
          "medium": "Call Back Form",
          "field_lead_priority": 'Gold',
          "field_reinquire": 'Yes',
          "field_page_location": this.sessionStorage.getItem('utmLink') ? this.doc.URL + '?' + this.sessionStorage.getItem('utmLink') : this.doc.URL

        }
        this.dashboardService.updateLeadSquared(reqData).subscribe((res: any) => {
          if (res) {
            this.callBackForm.reset()
          }
        })
      } else {
        this.callBackForm.reset()
      }
    })
  }

  joinwhatsapp() {
    window.open('https://chat.whatsapp.com/J9g4j8G0KL20Qoff2fO0c2', '_blank')
  }

 
  gotosection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
   
  }


}
